var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image"},[(_vm.cardImage)?_c('figure',{attrs:{"height":_vm.height}},[_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.cardImage),expression:"cardImage"}],attrs:{"rel":"noopener","alt":`Cardbild - ${_vm.altText}`}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }